import styled from 'styled-components';

export const QRContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: var(--bg-card);
  border-radius: 12px;
  border: 1px solid var(--border-light);
  margin: 0 auto;
  max-width: fit-content;
`;

export const QRCanvas = styled.canvas`
  border-radius: 8px;
  box-shadow: var(--shadow-md);
  background: var(--white);
  padding: 8px;
`;

export const QRInfo = styled.div`
  text-align: center;
  
  p {
    color: var(--text-secondary);
    font-size: 12px;
    margin-bottom: 12px;
    font-family: monospace;
  }
  
  .qr-actions {
    display: flex;
    gap: 8px;
    
    button {
      background: var(--bg-input);
      border: 1.5px solid var(--border-medium);
      color: var(--text-primary);
      padding: 6px 12px;
      border-radius: 6px;
      cursor: pointer;
      font-size: 12px;
      transition: all 0.3s ease;
      
      &:hover {
        background: var(--bg-section);
      }
    }
  }
`;